import { createSlice } from '@reduxjs/toolkit';

export const SizeFamilySlice = createSlice({
    name: 'sizefamily',
    initialState: {
        sizefamily: []
    },
    reducers: {
        setSizeFamilyRedux: ( state, { payload } ) => {
            state.sizefamily  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setSizeFamilyRedux } = SizeFamilySlice.actions;